import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from 'src/app/app.service';
import { faPersonCircleExclamation, faCalendarDays, faPerson } from '@fortawesome/free-solid-svg-icons';


@Component({
  selector: 'app-absence-detail-modal',
  templateUrl: './absence-detail-modal.component.html',
  styleUrls: ['./absence-detail-modal.component.css']
})
export class AbsenceDetailModalComponent implements OnInit {
AbsDetail:any;
type = "heatmap";
  dataFormat = "json";
  ChartDisplay:boolean= false;
  faPersonCircleExclamation = faPersonCircleExclamation;
  faCalendarDays=faCalendarDays;
  faPerson =faPerson;
  loading:boolean = false;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
          private srv: AppService,)
          {this.getStudentData();

          }

    DailyChartCurrent = {
            "chart": {
                "caption": "Daily % Attendance Report",
                //"subcaption": "In percentage",
                // "xaxisname": "Weeks",
                "yaxisname": "Week Days",
                "xAxisLabelsOnTop": "1",
                "showValues":"0",
                "showLegend":"1",
                "labelDisplay": "rotate",
                "showLabels": "1",
                "legendBgAlpha": "0",
                "legendBorderAlpha": "0",
                "legendShadow": "0",
                "legendItemFontSize": "10",
                "showPercentInTooltip": "0",
                "decimals": "1",

               // "numbersuffix": "%",
                "valueFontColor": "000000",
                "plottooltext": "<div id='nameDiv' style='font-size: 12px; border-bottom: 1px dashed #666666; font-weight:bold; padding-bottom: 3px; margin-bottom: 5px; display: inline-block; color: #888888;' ><b>$rowLabel </b>{br}$trLabel</div>{br}Absent : <b>$dataValue</b>{br} <b> $tlLabel</b>{br}<b></b>"

            }, "rows": {
              "row": [{
                "id": "MONDAY",
                "label": "MONDAY"
              }, {
                "id": "TUESDAY",
                "label": "TUESDAY"
              }, {
                "id": "WEDNESDAY",
                "label": "WEDNESDAY"
              }, {
                "id": "THURSDAY",
                "label": "THURSDAY"
              }, {
                "id": "FRIDAY",
                "label": "FRIDAY"
              }]
            },
            "columns": {
                "column": [
                    {
                        "id": "1",
                        "label": "Wk1"
                    },
                    {
                        "id": "2",
                        "label": "Wk2"
                    },
                    {
                        "id": "3",
                        "label": "Wk3"
                    }
                ]
            },
            "dataset": [
                {
                    "data": [
                        {
                            "rowid": "Mon",
                            "columnid": "1",
                            "value": "35",
                            "tlLabel": "Memorial Day",
                            "colorRangeLabel": "HOLIDAY"
                        },
                        {
                            "rowid": "Tue",
                            "columnid": "1",
                            "value": "95",
                            "colorRangeLabel": "ABOVE TARGET"
                        },
                        {
                            "rowid": "Wed",
                            "columnid": "1",
                            "value": "17",
                            "colorRangeLabel": "HOLIDAY"
                        },
                        {
                            "rowid": "Th",
                            "columnid": "1",
                            "value": "55.98",
                            "colorRangeLabel": "BELOW TARGET"
                        }
                    ]
                }
            ],
            "colorrange": {
               // "mapByCategory": "1",
                "gradient": "0",
               // "minvalue": "0",
                "color": [
                  {
                    "code": "ffffff",
                    "minvalue": "-2",
                    "maxvalue": "-2",
                    "Label":"Holi",
                    "label": "0 - HOLIDAY"
                },
                    {
                        "code": "399E38",
                        "minvalue": "0",
                        "maxvalue": "0",
                        "label": "PRESENT"
                    },
                    {
                      "code": "D3D3D3 ",
                      "minvalue": "-1",
                      "maxvalue": "-1",
                      "label": "1 -PENDING"
                  },
                    {
                        "code": "B41527",
                        "minvalue": "1",
                        "maxvalue": "1",
                        "label": "ABSENT"
                    }
                ]
            }
        }

    DailyChartPrevious = {
          "chart": {
            "caption": "Daily % Attendance Report",
            //"subcaption": "In percentage",
            // "xaxisname": "Weeks",
            "yaxisname": "Week Days",
            "xAxisLabelsOnTop": "1",
            "showValues":"0",
            "showLegend":"1",
            "labelDisplay": "rotate",
            "showLabels": "1",
            "legendBgAlpha": "0",
            "legendBorderAlpha": "0",
            "legendShadow": "0",
            "legendItemFontSize": "10",
            "showPercentInTooltip": "0",
            "decimals": "1",

           // "numbersuffix": "%",
            "valueFontColor": "000000",
            "plottooltext": "<div id='nameDiv' style='font-size: 12px; border-bottom: 1px dashed #666666; font-weight:bold; padding-bottom: 3px; margin-bottom: 5px; display: inline-block; color: #888888;' ><b>$rowLabel </b>{br}$trLabel</div>{br}Absent : <b>$dataValue</b>{br} <b> $tlLabel</b>{br}<b></b>"

          },
         "rows": {
            "row": [{
              "id": "MONDAY",
              "label": "MONDAY"
            }, {
              "id": "TUESDAY",
              "label": "TUESDAY"
            }, {
              "id": "WEDNESDAY",
              "label": "WEDNESDAY"
            }, {
              "id": "THURSDAY",
              "label": "THURSDAY"
            }, {
              "id": "FRIDAY",
              "label": "FRIDAY"
            }]
          },
          "columns": {
              "column": [
                  {
                      "id": "1",
                      "label": "Wk1"
                  },
                  {
                      "id": "2",
                      "label": "Wk2"
                  },
                  {
                      "id": "3",
                      "label": "Wk3"
                  }
              ]
          },
          "dataset": [
              {
                  "data": [
                      {
                          "rowid": "Mon",
                          "columnid": "1",
                          "value": "35",
                          "tlLabel": "Memorial Day",
                          "colorRangeLabel": "HOLIDAY"
                      },
                      {
                          "rowid": "Tue",
                          "columnid": "1",
                          "value": "95",
                          "colorRangeLabel": "ABOVE TARGET"
                      },
                      {
                          "rowid": "Wed",
                          "columnid": "1",
                          "value": "17",
                          "colorRangeLabel": "HOLIDAY"
                      },
                      {
                          "rowid": "Th",
                          "columnid": "1",
                          "value": "55.98",
                          "colorRangeLabel": "BELOW TARGET"
                      }
                  ]
              }
          ],
          "colorrange": {
             // "mapByCategory": "1",
              "gradient": "0",
             // "minvalue": "0",
             "color": [
              {
                "code": "ffffff",
                "minvalue": "-2",
                "maxvalue": "-2",
                "Label":"Holi",
                "label": "0 - HOLIDAY"
            },
                {
                    "code": "399E38",
                    "minvalue": "0",
                    "maxvalue": "0",
                    "label": "PRESENT"
                },
                {
                  "code": "D3D3D3 ",
                  "minvalue": "-1",
                  "maxvalue": "-1",
                  "label": "1 -PENDING"
              },
                {
                    "code": "B41527",
                    "minvalue": "1",
                    "maxvalue": "1",
                    "label": "ABSENT"
                }
            ]
          }
      }

  ngOnInit() {



  }
  getStudentData(){
    this.loading= true;
    this.srv.GetAbsentDetail(this.data.stu)
    .subscribe(detail=>{

      this.AbsDetail = detail;
      this.LoadDailyAttendance();
      this.loading=false;
    })
  }

  LoadDailyAttendance(){


    this.DailyChartCurrent.chart.caption =  this.AbsDetail.lstStudentDailyAttendance[0].fmtSchoolYear + "  " + this.DailyChartCurrent.chart.caption;
    var dsCurrent = this.AbsDetail.lstStudentDailyAttendance.map((da:any)=>{ return {"rowid": da.chartRowId, "columnid": da.chartColumnId, "value": da.chartValue, "tlLabel": da.dayType, "trLabel": da.fmtDate }})
    var columnsCurrent = this.AbsDetail.lstStudentDailyAttendance.map((da:any)=>{ return {"id": da.chartColumnId, "label": "Wk" +da.schoolWeek  }})

    var arrayUniqueByKey:any = [...new Map(columnsCurrent.map((item:any) =>
      [item["id"], item])).values()];


    this.DailyChartPrevious.chart.caption =  this.AbsDetail.lstStudentDailyAttendancePreviousYear[0].fmtSchoolYear + " " +  this.DailyChartPrevious.chart.caption;
    var dsPrevious= this.AbsDetail.lstStudentDailyAttendancePreviousYear.map((da:any)=>{ return {"rowid": da.chartRowId, "columnid": da.chartColumnId, "value": da.chartValue, "colorRangeLabel": da.chartColorRangeLabel, "tlLabel": da.dayType, "trLabel": da.fmtDate}})
    var columnsPrevious = this.AbsDetail.lstStudentDailyAttendancePreviousYear.map((da:any)=>{ return {"id": da.chartColumnId, "label": "Wk" + da.schoolWeek }})

    var arrayUniqueByKeyPrevious:any = [...new Map(columnsPrevious.map((item:any) =>
      [item["id"], item])).values()];


    this.DailyChartCurrent.columns.column = arrayUniqueByKey;
    this.DailyChartCurrent.dataset[0].data = dsCurrent;

    this.DailyChartPrevious.columns.column = arrayUniqueByKeyPrevious;
    this.DailyChartPrevious.dataset[0].data = dsPrevious;


      this.ChartDisplay = true;
  }

}
